'use client';

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { AdSortByEnum, Statistic } from '@/__generated_graphql__/graphql';
import { ROUTES } from '@/constants/common';

import * as S from './Dashboard.styles';

type Props = {
  statistic?: Statistic;
  isResumes?: boolean;
};

export const AdStatisticBar = ({ statistic, isResumes }: Props) => {
  const { t } = useTranslation();
  const link = useMemo(() => {
    const searchPath = isResumes
      ? ROUTES.SEARCH_RESUMES
      : ROUTES.SEARCH_VACANCIES;

    const searchParams = new URLSearchParams({
      sortBy: AdSortByEnum.Date
    });

    return `${searchPath}?${searchParams.toString()}`;
  }, [isResumes]);

  return (
    <S.StatisticTitle>
      <S.StatisticLink href={link} $isResumes={isResumes} prefetch={false}>
        {t('MainPage.statistic_days')}
        <S.HightlightText $isResumes={isResumes}>
          {statistic?.week ?? ''}
        </S.HightlightText>
        {t(`MainPage.statistic_${isResumes ? 'resumes' : 'vacancies'}`)}
      </S.StatisticLink>
    </S.StatisticTitle>
  );
};
